import locales from './locales.js';
export default locales[0];
//# sourceMappingURL=defaultLocale.js.map